import { JSX } from 'react';
import {
  IMappedGroupScheduleWithoutDate,
  IMappedTeacherScheduleWithoutDate,
} from 'entities/types';

import {
  GroupRowTableSchedule,
  TeacherRowTableSchedule,
} from '../../rowTableSchedule';

export const makeRows = (
  data: IMappedGroupScheduleWithoutDate[] | IMappedTeacherScheduleWithoutDate[],
  isGroupSchedule: boolean,
  isEven: boolean,
) => {
  const rows: JSX.Element[] = [];
  if (isGroupSchedule) {
    data.forEach((item) => {
      if ((item as IMappedGroupScheduleWithoutDate).isEven === isEven) {
        rows.push(
          <GroupRowTableSchedule
            data={item as IMappedGroupScheduleWithoutDate}
            key={item.key}
          />,
        );
      }
    });
  } else {
    data.forEach((item) => {
      if ((item as IMappedTeacherScheduleWithoutDate).isEven === isEven) {
        rows.push(
          <TeacherRowTableSchedule
            data={item as IMappedTeacherScheduleWithoutDate}
            key={item.key}
          />,
        );
      }
    });
  }

  return rows;
};
